<template>
    <div class="notification">
        <div class="notification__icon">
            <i class="mdi mdi-bell-ring" :style="{'color': data.template.color}"></i>
        </div>
        <div class="notification__body">
            <h3 class="text-white">{{header.name}}</h3>
            <span>{{header.body}}</span>
            <button
                type="button"
                class="btn-open"
                @click="getLastAddedLesson"
            >
                {{$t('common.open')}}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "Toast",

    props: {
        data: {
            type: Object,
            required: true
        },
        language: Object,
    },

    methods: {
        findTranslation(item, language) {
            if (language && item.translations) {
                return item.translations.findIndex(
                    item =>
                        item.language_id == language.id ||
                        item.iso === language.iso
                );
            }
            return -1;
        },

        async getLastAddedLesson() {
            var planId = parseInt(this.data.link.replace('/app/plan/', ''));
            return window.axios
                .get(`/api/plan/${planId}/lesson/last-added`)
                .then((res) => {
                    console.log(planId);
                    if (res.data.redirectLink === '') {
                        window.location.href = this.data.link + res.data.originalLink;
                    } else {
                        window.location.href = this.data.link + res.data.redirectLink;
                    }
                })
                .catch((err) => {
                    console.error(err);
                    window.location.href = '/app/plan/'+ planId;
                });
        },
    },

    computed: {
        header() {
            const index = this.findTranslation(
                this.data.template,
                this.language
            );
            return this.data.template.translations[index];
        },
    },
};
</script>

<style lang="scss" scoped>
.notification {
     display: inline-flex;
    align-items: center;

    &__icon {
        background-color: #ffffff;
        min-height: 55px;
        min-width: 55px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        margin-right: 20px;

        & i {
           font-size: 30px;
           margin: auto;
        }
    }
}

.link {
    color: #ffffff;
}

.btn-open {
    color: #ffffff;
    font-size: 16px;
    background-color: #1976d2;
    border: none;
    cursor: pointer;
}
</style>